import { render, staticRenderFns } from "./DataScreenOld.vue?vue&type=template&id=b1dc72de&scoped=true"
import script from "./DataScreenOld.vue?vue&type=script&lang=js"
export * from "./DataScreenOld.vue?vue&type=script&lang=js"
import style0 from "./DataScreenOld.vue?vue&type=style&index=0&id=b1dc72de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc72de",
  null
  
)

export default component.exports